import { RadioGroup } from "../Controls/RadioGroup";
import './css/SkitterBookImageMargin.css';

interface SkitterBookImageMarginProps {
    imageMarginMm: number;
    onChange?: (val: number) => void;
}

export const SkitterBookImageMargin: React.FC<SkitterBookImageMarginProps> = ({ imageMarginMm, onChange }) => {
    return (
        <>
            <RadioGroup
                name="frameIntervalGroup"
                value={imageMarginMm.toString()}
                onChange={(val: string) => onChange?.(Number.parseInt(val))}
                options={[
                    { value: "0", label: "No Margin" },
                    { value: "1", label: "1mm" },
                    { value: "2", label: "2mm" },
                    { value: "3", label: "3mm" },
                    { value: "4", label: "4mm" },
                    { value: "5", label: "5mm" }
                ]}
                colors={{
                    border: "var(--color-static-background)",
                    foreground: "var(--color-component-foreground)",
                    background: "var(--color-component-background)",
                    hover: "var(--color-component-foreground)"
                }}
                className="frame-interval-group"
            />
        </>
    );
};
